import './tabledata.css';

function TableData({ data, headerTag, activeTab }) {

    return (
        <div className="table-wrapper">
            <table className="rounded-corners table-header">
                <thead>
                    <tr>
                        <th>{headerTag}</th>
                        {headerTag !== 'Task Type' && activeTab === 'Work Type' && <th>Work Type</th>}
                        {(activeTab === 'Task Type') ? <th>New</th> : <th>Completed</th>}
                        {(activeTab === 'Task Type') ? <th>Mod</th> : <th>Ongoing</th>}
                        {(activeTab === 'Task Type') ? <th>Overdue</th> : <th>Upcoming</th>}
                        {activeTab === 'Work Type' && <th>Total</th>}
                        <th>Grand Total</th>
                    </tr>
                </thead>
            </table>

            <div className="table-scroll-body">
                <table className="rounded-corners table-body">

                    <tbody>
                        {activeTab === 'Work Type' ? (
                            (() => {
                                const rows = [];
                                const length = data.length;
                                let i = 0;

                                while (i < length) {
                                    const current = data[i];

                                    if (current.Vertical !== null) {
                                        // Push the current and next 2 rows as a group
                                        const group = [current];

                                        if (i + 1 < length && data[i + 1].Vertical === null) group.push(data[i + 1]);
                                        if (i + 2 < length && data[i + 2].Vertical === null) group.push(data[i + 2]);

                                        const baseIndex = i;
                                        const rowSpan = group.length;
                                        group.forEach((row, idx) => {
                                            rows.push(
                                                <tr key={baseIndex + idx}>
                                                    {idx === 0 && <td rowSpan={rowSpan}>{row.Vertical}</td>}
                                                    <td>{row.WorkType}</td>
                                                    <td>{row.Completed ?? '0'}</td>
                                                    <td>{row.Ongoing ?? '0'}</td>
                                                    <td>{row.Upcoming ?? '0'}</td>
                                                    <td>{row.Total ?? '0'}</td>
                                                    {idx === 0 && <td rowSpan={rowSpan}>{row["Grand Total"] ?? '0'}</td>}
                                                </tr>
                                            );
                                        });

                                        i += group.length;
                                    } else {
                                        // Safety fallback (shouldn't happen with your current data)
                                        i++;
                                    }
                                }

                                return rows;
                            })()
                        ) : (
                            data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {Object.values(row).map((cell, i) => {
                                        const isGrandTotal = Object.values(row).includes("Grand Total");
                                        if (isGrandTotal) return null; // Handle grand total separately
                                        return (
                                            <td key={i}>
                                                {(cell !== null && typeof cell !== 'object') ? cell : '0'}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))
                        )}
                    </tbody>

                </table>
            </div>

            <table className="rounded-corners table-footer">
                <tfoot>
                    {data.map((row, index) => {
                        const isGrandTotal = Object.values(row).includes("Grand Total");
                        if (!isGrandTotal) return null;

                        return (
                            <tr key={index} className="grand-total-row">
                                {Object.keys(row).map((key, i) =>
                                    row[key] !== null ? <td key={i}>{row[key]}</td> : <td key={i}>0</td>
                                )}
                            </tr>
                        );
                    })}
                </tfoot>
            </table>
        </div>
    );

}

export default TableData;
